// pages/Info/Info.jsx
import React, { useEffect } from "react";
import styles from "./Info.module.css";
import HeroSection from "./components/HeroSection";
import DualSubtitleDemo from "./components/DualSubtitleDemo";
import InstantTranslateDemo from "./components/InstantTranslateDemo";
import SmartWordsSection from "./components/SmartWordsSection";
import LightnerSection from "./components/LightnerSection";
import ShadowingSection from "./components/ShadowingSection";
import HowItWorks from "./components/HowItWorks";
import DictionariesSection from "./components/DictionariesSection";
import FinalCTA from "./components/FinalCTA";

const Info = () => {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 150);
      }
    }
  }, []);

  const scrollToFeatures = () => {
    const el = document.getElementById("features");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className={styles.page}>
      <HeroSection onViewFeatures={scrollToFeatures} />
      <main className={styles.sections}>
        <DualSubtitleDemo />
        <InstantTranslateDemo />
        <SmartWordsSection />
        <LightnerSection />
        <ShadowingSection />
        <HowItWorks />
        <DictionariesSection />
        <FinalCTA />
      </main>
    </div>
  );
};

export default Info;